import { render, staticRenderFns } from "./createPVautoCenter.vue?vue&type=template&id=4bffa145&"
import script from "./createPVautoCenter.vue?vue&type=script&lang=js&"
export * from "./createPVautoCenter.vue?vue&type=script&lang=js&"
import style0 from "./createPVautoCenter.vue?vue&type=style&index=0&id=4bffa145&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports